import { render, staticRenderFns } from "./FirstLogin.vue?vue&type=template&id=5f6c3b9f&scoped=true&lang=pug&"
import script from "./scripts/FirstLogin.js?vue&type=script&lang=js&"
export * from "./scripts/FirstLogin.js?vue&type=script&lang=js&"
import style0 from "./FirstLogin.vue?vue&type=style&index=0&id=5f6c3b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c3b9f",
  null
  
)

export default component.exports